import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Box,
  IconButton
} from '@mui/material'
import AddBoxIcon from '@mui/icons-material/AddBox'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'

import { tableRowBackGroundColorSelect } from '../../components/table/table.utils'
import SelectedObject from './selectedObject'
import AdminDialog from './adminDialog'
import {
  removeAdminData,
  setDialogDataAction,
  updateAdminData
} from '../../store/pages/adminTool'

const CellSmall = styled(TableCell)({ width: '100px' })
const CellMedium = styled(TableCell)({ width: '200px' })
const CellLarge = styled(TableCell)({ width: '400px' })

const ScrollWrapper = styled(Box)({
  maxWidth: '87vw',
  overflowX: 'auto'
})

export default function Announcements () {
  const dispatch = useDispatch()
  const { dialogData, announcementData, ownerId } = useSelector(({ adminTool, user }) => ({
    dialogData: adminTool.dialogData,
    announcementData: adminTool.announcementData,
    ownerId: user.ownerId
  }))

  const [selectedRow, setSelectedRow] = React.useState(null)
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [title, setTitle] = React.useState(null)

  const newObject = {
    visible: true,
    startDate: null,
    endDate: null,
    userId: ownerId,
    type: 'announcement',
    name: null,
    description: null,
    message: null,
    title: null
  }

  const handleAddClick = () => {
    dispatch({ ...setDialogDataAction, payload: newObject })
    setDialogOpen(true)
    setTitle('Add New Announcement')
  }

  const handleEditClick = (row, index) => {
    setSelectedRow(index)
    dispatch({ ...setDialogDataAction, payload: row })
    setDialogOpen(true)
    setTitle('Edit Announcement')
  }

  const handleDeleteClick = (row) => {
    dispatch(removeAdminData(row))
  }

  return (
    <Box display="flex" gap={2}>
      <Box flex={5}>
        <ScrollWrapper>
          <Table size="small" aria-label="announcement table">
            <TableHead>
              <TableRow>
                <CellLarge>Name</CellLarge>
                <CellMedium>Release</CellMedium>
                <CellSmall />
                <CellSmall>
                  <Tooltip title="Add New Announcement">
                    <IconButton onClick={handleAddClick}>
                      <AddBoxIcon />
                    </IconButton>
                  </Tooltip>
                </CellSmall>
              </TableRow>
            </TableHead>

            <TableBody>
              {announcementData?.map((row, idx) => (
                <TableRow
                  key={idx}
                  sx={tableRowBackGroundColorSelect(idx, selectedRow)}
                  onClick={() => {
                    setSelectedRow(idx)
                    dispatch({ ...setDialogDataAction, payload: row })
                  }}
                >
                  <CellLarge>{row.name}</CellLarge>
                  <CellMedium>{row.endDate}</CellMedium>
                  <CellSmall>
                    <IconButton onClick={() => handleEditClick(row, idx)}>
                      <EditIcon />
                    </IconButton>
                  </CellSmall>
                  <CellSmall>
                    <IconButton onClick={() => handleDeleteClick(row)}>
                      <DeleteIcon data-testid="DeleteIcon" />
                    </IconButton>
                  </CellSmall>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollWrapper>

        {dialogData && (
          <AdminDialog
            update={data => dispatch(updateAdminData(data))}
            type={dialogData.type}
            open={dialogOpen}
            title={title}
            setDialogOpen={setDialogOpen}
          />
        )}
      </Box>

      <Box flex={7}>
        {dialogData?.guid && <SelectedObject data={dialogData} />}
      </Box>
    </Box>
  )
}
